var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import UtilityClasses from 'nucleus-core/less/Utility.less';
import LocationMapClasses from './LocationMap.less';
import { injectTestId } from '@cvent/nucleus-test-automation';
export function GoogleMap(props) {
    var translate = props.translate, googleApiKey = props.googleApiKey, clickable = props.clickable, width = props.width, height = props.height, scale = props.scale, zoom = props.zoom, urlAddress = props.urlAddress;
    // NOTE: dropped center parameter and use a single marker to set center
    var uri = 'https://maps.googleapis.com/maps/api/staticmap?' +
        ("markers=" + urlAddress + "&zoom=" + zoom + "&size=" + width + "x" + height + "&scale=" + scale + "&key=" + googleApiKey);
    if (clickable) {
        return (React.createElement("a", __assign({}, injectTestId('google-location-map-link'), { target: "_blank", href: "https://maps.google.com/?q=" + urlAddress }),
            React.createElement("div", { "aria-label": translate('EventWidgets_LocationMap_GoogleMapAriaAlt__resx'), className: LocationMapClasses.map, role: "img", style: { backgroundImage: "url(\"" + uri + "\")" } },
                React.createElement("span", { className: UtilityClasses.hidden }, translate('EventWidgets_LocationMap_GoogleMapAriaAlt__resx')))));
    }
    return (React.createElement("div", __assign({}, injectTestId('google-location-map-link'), { className: LocationMapClasses.map, role: "img", style: { backgroundImage: "url(\"" + uri + "\")" }, "aria-label": translate('EventWidgets_LocationMap_GoogleMapAriaAlt__resx') }),
        React.createElement("span", { className: UtilityClasses.hidden }, translate('EventWidgets_LocationMap_GoogleMapAriaAlt__resx'))));
}
GoogleMap.defaultProps = {
    clickable: true,
    width: 640,
    height: 480,
    scale: 2,
    zoom: 15
};
